import { TwcOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { ReturnToProduct } from '@/components/signup/site-activation/components/common/return-to-product';
import { ExistingUser } from '@/components/signup/site-activation/components/existing-user/existing-user';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { Headings } from '../../components/headings';
import { PickUpWhereYouLeftOffText } from '../../components/sub-heading';
import { WelcomeBackText } from '../../components/welcome-back-heading';

export const CurrentProductUser = () => (
	<TwcOverlayTemplate size="sm">
		<Headings main={<WelcomeBackText />} sub={<PickUpWhereYouLeftOffText />} />
		{/* everyone with a teamwork collection should see a return to product experience */}
		<SiteActivation
			CurrentProductUser={<ReturnToProduct ExistingUser={<ExistingUser SitePicker={null} />} />}
		/>
	</TwcOverlayTemplate>
);
